import React from 'react';

type LoadingProps = {
  className?: string;
};

function Loading({className}: LoadingProps) {
  return (
    <div className={`flex w-full h-full-24 overflow-auto ${className || ''}`}>
      <p className="text-6xl m-auto">Loading...</p>
    </div>
  );
}

export default Loading;
